import { createActions } from 'src/utils/createActions';
import { OrganizationListData } from 'src/react/organization/state/OrganizationListData';

export const ORGANIZATION_LIST_SEED_ACTIONS =
    createActions<OrganizationListData | null, OrganizationListData | null>('ORGANIZATION_LIST_SEED');
